/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProfileDetailDto
 */
export interface AdminProfileDetailDto {
    /**
     * Admin user ID
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    id: string;
    /**
     * Admin email address
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    email: string;
    /**
     * Admin first name
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    firstName: string;
    /**
     * Admin middle name
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    middleName?: string;
    /**
     * Admin last name
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    lastName: string;
    /**
     * Admin phone number
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    phone?: string;
    /**
     * Admin avatar URL
     * @type {string}
     * @memberof AdminProfileDetailDto
     */
    avatar?: string;
    /**
     * Whether the admin account is active
     * @type {boolean}
     * @memberof AdminProfileDetailDto
     */
    isActive: boolean;
    /**
     * Account creation date
     * @type {Date}
     * @memberof AdminProfileDetailDto
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the AdminProfileDetailDto interface.
 */
export function instanceOfAdminProfileDetailDto(value: object): value is AdminProfileDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function AdminProfileDetailDtoFromJSON(json: any): AdminProfileDetailDto {
    return AdminProfileDetailDtoFromJSONTyped(json, false);
}

export function AdminProfileDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProfileDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'isActive': json['isActive'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function AdminProfileDetailDtoToJSON(json: any): AdminProfileDetailDto {
    return AdminProfileDetailDtoToJSONTyped(json, false);
}

export function AdminProfileDetailDtoToJSONTyped(value?: AdminProfileDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
        'avatar': value['avatar'],
        'isActive': value['isActive'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

